import { useContext, useEffect } from "react"
import { Button, Modal } from "../../../../../components"
import { FormSection } from "./FormSection"
import * as yup from "yup"
import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import toast from "react-hot-toast"
import type { ListBank } from "../types"
import { useApi } from "../../../../../utils"
import { Render, useCode } from "../utils"

export function CreateModal(props: {
  group_coa_id?: number
  account_type_code?: string
  account_type_name?: string
  description?: string 
  toggle: () => void
  refetch?: () => void
}) {

  const api = useApi()
  const { toggle } = useContext(Render)

  const { dataCode} = useCode()

  useEffect(() => {
    if (dataCode?.code) {
      methods.setValue("account_type_code", dataCode?.code)
    }
 // eslint-disable-next-line
  }, [dataCode?.code])

  type CreateListBank = Omit<ListBank, "group_coa_id" | "account_type_id" | "group_coa_type" | "group_coa_name"> 

  const defaultValues = {
    group_coa_id: props.group_coa_id ?? 1,
    account_type_code: "",
    account_type_name: "",
    description: "",
  }
  const validationSchema = yup.object().shape({
    account_type_code: yup.string().label("Code").required().max(3, 'Maximum code is 3 characters'),
    account_type_name: yup.string().label("Name Type").required(),
    description: yup.string().label("Description").optional(),
  })
  const onSubmit = (value: CreateListBank) => {
    return new Promise<void>((resolve) => {
      toast.promise(
        api.post("/acctype/add", value),
        {
          loading: "Loading...",
          success: (res) => res.data.message,
          error: (err) => {
            if (err.response && err.response.status === 409 ) {
              return err.response.data.message || err.response.data.detail.message;
            } else {
              return "An error occurred";
            }
          }
        }
      ).then(() => {
        props.toggle()
        props?.refetch && props.refetch()
        toggle()
      }).catch(() => {}).finally(resolve)
    })
  }
  const methods = useForm<CreateListBank>({
    defaultValues,
    resolver: yupResolver(validationSchema)
  })
  console.log(methods.formState.errors)

  return (
    <Modal isOpen title="CREATE COA TYPE" size="xl" closeModal={props.toggle}>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <FormSection />

          <Modal.Footer className="text-end">
            <Button type="submit" color="primary" loading={methods.formState.isSubmitting ? "true" : undefined}>Save</Button>
          </Modal.Footer>
        </form>
      </FormProvider>
    </Modal>
  )
}